import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { Modal } from '../../../ui'
import { ButtonsBlock } from '../../../Edit/components'
import { fetchDecline } from '../../config'
import style from './style.m.less'
import useRequest from '../../../hooks/useRequest'
import { QuestionCircle } from '../../../../assets/icons'
import {signBody} from "../../../helpers";
import { Alert } from 'antd'

interface ICloseEditModal {
    isModalVisible: boolean
    setIsModalVisible: (value: boolean) => void
    data: any
    userData: any
    isSignExpired: boolean
    isEmptyAttorney: boolean
    isAttorneyExpired: boolean
}

const CloseEditModal: FC<ICloseEditModal> = (
    {
        isModalVisible,
        setIsModalVisible,
        data,
        userData,
        isSignExpired,
        isEmptyAttorney,
        isAttorneyExpired
    }
) => {
    const { t } = useTranslation()
    const { ts_created } = data
    const navigate = useNavigate()
    const { fetch } = useRequest(fetchDecline)

    const handleOk = () => {
        setIsModalVisible(false)
    }

    const getBack = () => {
        fetch({
            body: {
                ts_created,
            },
            errorCodeMessage: true,
            onSuccess: () => navigate('/user-my-green-tools'),
        })
    }

    const confirmCancel = async () => {
        const body = {
            ts_created,
        }
        const { request_id, signature } = await signBody(body, userData)
        fetch({
            body,
            getParams: {
                request_id,
            },
            config: {
                headers: {
                    Signature: signature,
                },
            },
            errorCodeMessage: true,
            onSuccess: () => navigate('/user-my-green-tools'),
        })
    }

    return (
        <Modal isModalVisible={isModalVisible}>
            <div className={style.modalWrapper}>
                <div className={style.headerWrapper}>
                    <QuestionCircle />
                    <div className={style.header}>Отказаться от согласования</div>
                </div>
            </div>
            <div className={style.text}>
                Вы уверены, что хотите отказаться от подтверждения добавления сторонних
                инструментов?
            </div>
            {isSignExpired && (
                <Alert
                    className={style.signError}
                    message={'Истек срок действия ЭП'}
                    type="error"
                    showIcon
                />
            )}
            {(isEmptyAttorney || isAttorneyExpired) && (
                <Alert
                    className={style.signError}
                    message={isEmptyAttorney ? t('profile.attorneyIsMissing') : t('profile.attorneyIsExpired')}
                    type="error"
                    showIcon
                />
            )}
            <div className={style.buttonsBlock}>
                <ButtonsBlock
                    isDelete
                    confirmAction={confirmCancel}
                    cancelAction={handleOk}
                    confirmTitle={'Отказаться'}
                    confirmDisabled={isSignExpired || isEmptyAttorney || isAttorneyExpired}
                />
            </div>
        </Modal>
    )
}

export default CloseEditModal
